// @core/api/endpoints/task/add_task_watcher.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AddTaskWatcherRequest,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Add task watcher
 * Adds an actor as a watcher on the task. Watchers receive notifications for all task updates including status changes and comments.
 */
export async function AddTaskWatcher(
  task_id: string,
  data: AddTaskWatcherRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/tasks/:task_id/watchers`;
  requestPath = requestPath.replace(':task_id', encodeURIComponent(task_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
